<template>
    <div class="divs" v-loading.fullscreen.lock="allLoading">
        <top />
        <div class="search">
            <el-form ref="form" :model="form" label-width="70px">
                <label>科室</label>
                <el-select v-model="form.parent"
                           multiple
                           placeholder="请选择"
                           size="small"
                           collapse-tags
                           @keyup.enter="search">
                    <el-option v-for="item in ks"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
                <label>单位名称</label>
                <el-input v-model="form.name"
                          size="small"
                          clearable
                          @keyup.enter="search"></el-input>
                <label>导入状态</label>
                <el-select v-model="form.state"
                           placeholder="请选择"
                           size="small"
                           :clearable="clearable"
                           @keyup.enter="search"
                           style="width:15%">
                    <el-option v-for="item in statusData"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
                <label>类型</label>
                <el-select v-model="form.type"
                           placeholder="请选择"
                           size="small"
                           :clearable="clearable"
                           @keyup.enter="search">
                    <el-option v-for="item in lxSelectData"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
                <label>功能科目</label>
                <el-input v-model="form.km"
                          size="small"
                          @keyup.enter="search"></el-input>
                <el-button type="primary" size="small" @click="search">搜索</el-button>
                <el-button size="small" @click="check" v-if="$store.state.userDetail.permissions && $store.state.userDetail.permissions.find(ele => ele == 'dde50146d63246afbfe13da479c6cc8b') && $cookies.get('district')=='山东' && ($store.state.openYear==2020 || $store.state.openYear==2022)">校验</el-button>
                <!-- <el-button type="primary" size="small" @click="$router.push({name:'公开页面'})">单位公开</el-button> -->
            </el-form>

            <div class="gongneng">
                <span @click="tongyi" v-if="tgShow">
                    <img src="../assets/shtg.png" width="45" height="45" />
                </span>
                <span @click="tuihui" v-if="thShow">
                    <img src="../assets/shth.png" width="45" height="45" />
                </span>
                <span @click="fabu" v-if="bmType !== '部门' && fbShow">
                    <img src="../assets/fb.png" width="45" height="45" />
                </span>
                <span @click="pldr" v-if="bmType !== '部门' && bmType !== '科室'">
                    <img src="../assets/pldr.png" width="45" height="45" />
                </span>
                <span @click="goUser" v-if="bmType !== '部门' && bmType !== '科室'">
                    <img src="../assets/more.png" width="45" height="45" />
                </span>
                <span @click="downmultiplepdf" v-if="$store.state.userDetail.permissions && $store.state.userDetail.permissions.find(ele => ele == 'f2e9c993fcb04990a07e8616416d2dab') ">
                    <img src="../assets/opdfs.png" width="45" height="45" />
                </span>
            </div>
        </div>
        <el-table :data="tableData"
                  ref="tableRef"
                  :height="tableHeight"
                  tooltip-effect="dark"
                  style="width: 100%"
                  @selection-change="selectChange"
                  row-key="id"
                  :tree-props="{children: 'children'}"
                  @select="rowSelect"
                  @select-all="selectAll"
                  default-expand-all>
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column label="单位名称" width="500">
                <template #default="scope">
                    <span @click="divClick(scope.row)" style="cursor: pointer" :class="{active:scope.row.isActive}">
                        {{ scope.row.name }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="科室">
                <template #default="scope">
                    <span>{{ scope.row.parentName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="类型">
                <template #default="scope">
                    <span>{{ scope.row.type == 0 ? '单位' : '部门' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="单位编码" sortable :sort-method="sortscope">
                <template #default="scope">
                    <span>{{ scope.row.code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="导入状态">
                <template #default="scope">
                    <span>{{hostname.indexOf('liaocheng.21js')>-1 ? (!isEmptyStr(scope.row.stateName) ? scope.row.stateName : stateName()[scope.row.state]) : stateName()[scope.row.state] }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" v-if="lxShow">
                <template #default="scope">
                    <el-button type="text" size="small" @click="doDetail(scope.row.id)">查看联系人</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="footer">
            <div class="footer-c" style="cursor: pointer;" @click="doSearch()">
                汇总: {{lengthList.单位 + lengthList.部门}}
            </div>
            <div style="display:flex" v-show="lengthList.单位 + lengthList.部门 != 0">
                其中:
                <div v-for="(value,key) in lengthList" :key="key">
                    <div class="footer-c" style="cursor: pointer;" v-if="value != 0" @click="doSearch(key)">{{key}} {{value}}</div>
                </div>
                状态:
                <div v-for="(value,key) in stateLengthList" :key="key">
                    <div class="footer-c" style="cursor: pointer;" v-if="value != 0" @click="doSearch(key)">{{key}} {{value}}</div>
                </div>
            </div>
        </div>
        <el-dialog title="个人信息" v-model="dialogTableVisible" width='70%'>
            <el-table :data="grData" class="grData">
                <el-table-column prop="loginId" label="用户"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="qq" label="QQ"></el-table-column>
                <el-table-column prop="phone" label="联系电话"></el-table-column>
                <el-table-column prop="email" label="邮箱"></el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="校验列表" v-model="dialogCheckVisible" width='70%'>
            <el-table :data="checkData" class="grData">
                <el-table-column prop="divname" label="单位名称"></el-table-column>
                <el-table-column label="校验消息">
                    <template #default="scope">
                        <span v-html="scope.row.message"></span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="pdf错误列表" v-model="dialogdownLoadVisible" width='70%'>
            <div v-for="(item,index) in pdfErrorList" :key="index">
                <div v-if="index == '未上传'">
                    单位未上传！
                    <p v-for="(items) in item" style="color:red">
                        {{items}}
                    </p>  
                </div>
                <div v-if="index == '财政审核'">
                    单位请联系财政审核！
                    <p v-for="(items) in item" style="color:red">
                        {{items}}
                    </p>  
                </div>
                <div v-if="index == '服务器繁忙'">
                    单位服务器繁忙或暂时维护，请单独下载！
                    <p v-for="(items) in item" style="color:red">
                        {{items}}
                    </p>  
                </div>
                <div v-if="index == '格式错误'">
                    格式错误,需单独下载！
                    <p v-for="(items) in item" style="color:red">
                        {{items}}
                    </p>  
                </div>
                <div v-if="index == '下载出错'">
                    单位下载出错，请单独下载！
                    <p v-for="(items) in item" style="color:red">
                        {{items}}
                    </p>  
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import top from "@/components/top.vue";
    import { getPdfFileNameProfile } from "@/api/zone.js";
    import {
        getDivsList,
        getDivList,
        tongyi,
        fabu,
        tuihui,
        downLoadpdf, getPerformanceList
    } from "@/api/index.js";
    import { getUsers, user } from '@/api/user.js';
    import { getBdata } from "@/api/zone.js";
    export default {
        name: "index",
        data() {
            return {
                tableHeight: document.documentElement.clientHeight - 198,
                allLoading: false,
                tableData: [],
                oldData: [],
                selectData: [],
                lxSelectData: [],
                form: {
                    zone: "",
                    parent: "",
                    name: "",
                    state: "",
                    km: "",
                    type: "",
                },
                htmlurl: '',
                typeText: '',
                linkName: false,
                parent: "",
                ks: [],
                statusData: [],
                clearable: true,
                childrenType: false, //判断是否存在children
                bmType: localStorage.getItem('name'),
                tgShow: false,
                thShow: false,
                lxShow: false,
                fbShow: false,
                pdfNameConfig: '',
                //下载错误的单位名数组
                errorpromises: [],
                users: [],
                grData: [],
                dialogTableVisible: false,
                dialogCheckVisible: false,
                dialogdownLoadVisible: false,
                checkData: [],
                lengthList: {},
                stateLengthList: {},
                openYear: this.$store.state.openYear,
                pdfErrorList: {},
                hostname:window.location.hostname
            };
        },
        props: {
            userDetail: {
                type: Array,
                default: () => [],
            },
        },
        components: {
            top,
        },
        mounted() {
            this.init()
            // 清除本地缓存
            sessionStorage.removeItem("hop");
            sessionStorage.removeItem("dataIndex");
            localStorage.removeItem("userpathKey");
            localStorage.removeItem("tableRows");
        },
        methods: {
            async doDetail(id) {
                let res = await getUsers()
                if (res.status == 0) {
                    this.users = res.users
                    this.grData = []
                    this.users.forEach(ele => {
                        ele.divids.forEach(el => {
                            if (id == el) {
                                this.grData.push(ele)
                            }
                        })
                    })
                    this.dialogTableVisible = true
                }
            },
            async init() {
                this.getDivsList();
            },
            async getDivsList() {
                this.allLoading = true;
                let res = await getDivsList({ km: this.form.km });
                if (res.status == 0) {
                    //type：0单位，1科室，2部门；只显示单位、部门
                    this.oldData = []
                    res.divs.forEach(ele => {
                        ele.type != 1 ?
                            this.oldData.push(ele) :
                            ''
                    })
                    res.divs.forEach(ele => {
                        ele.children = []
                    })
                    this.lengthList.部门 = res.divs.filter(u => u.parentName) ? res.divs.filter(u => u.type == 2 && u.parentName.indexOf('测试') == -1).length : 0
                    this.lengthList.单位 = res.divs.filter(u => u.parentName) ? res.divs.filter(u => u.type == 0 && u.parentName.indexOf('测试') == -1).length : 0
                    this.stateLengthList.未导入 = res.divs.filter(u => u.parentName) ? res.divs.filter(u => u.state == 0 && u.type != 1 && u.parentName.indexOf('测试') == -1).length : 0
                    this.stateLengthList.已导入 = res.divs.filter(u => u.parentName) ? res.divs.filter(u => u.state == 1 && u.type != 1 && u.parentName.indexOf('测试') == -1).length : 0
                    this.stateLengthList.审核成功 = res.divs.filter(u => u.parentName) ? res.divs.filter(u => u.state == 2 && u.type != 1 && u.parentName.indexOf('测试') == -1).length : 0
                    this.stateLengthList.退回 = res.divs.filter(u => u.parentName) ? res.divs.filter(u => u.state == 3 && u.type != 1 && u.parentName.indexOf('测试') == -1).length : 0
                    this.stateLengthList.待审 = res.divs.filter(u => u.parentName) ? res.divs.filter(u => u.state == 4 && u.type != 1 && u.parentName.indexOf('测试') == -1).length : 0
                    this.stateLengthList.已经发布 = res.divs.filter(u => u.parentName) ? res.divs.filter(u => u.state == 5 && u.type != 1 && u.parentName.indexOf('测试') == -1).length : 0
                    for (let i = res.divs.length - 1; i >= 0; i--) {
                        if ((res.divs[i].bm)) {
                            let a = res.divs.find(item => item.id == res.divs[i].bm)
                            if (a) {
                                a.children.push(res.divs[i])
                                a.children.sort(function (a, b) {
                                    return a.autoid - b.autoid
                                })
                                res.divs.splice(i, 1)
                                this.childrenType = true //如果有children,开关打开
                            } else {
                                // console.log(res.divs[i])
                            }

                        }
                    }
                    res.divs.forEach(ele => {
                        ele.isActive = ele.children.length == 0 ? true : false
                    })
                    this.tableData = res.divs.filter(
                        (e) => e.type != 1,
                        function () {
                            this.$store.commit("changeType", e.type);
                            return e.type;
                        }
                    ).sort(function (a, b) {
                        return a.autoid - b.autoid
                    });

                    this.allLoading = false;

                    //给科室赋值
                    if (this.ks.length == 0) {
                        let arr = res.divs
                            .filter((e) => {
                                return e.ks
                            })
                            .map((e) => {
                                return {
                                    id: e.ks,
                                    name: e.parentName,
                                };
                            });
                        res.divs.forEach(el => {
                            if (el.children) {
                                el.children.forEach(ele => {
                                    if (ele.ks && ele.parentName) {
                                        let a = {
                                            id: ele.ks,
                                            name: ele.parentName,
                                        }
                                        arr.push(a)
                                    }
                                })
                            }
                        })
                        let obj = {};
                        for (const item of arr) {
                            obj[item.name + "," + item.age] = item;
                        }
                        this.ks = Object.values(obj);
                        this.statusData = [
                            {
                                label: "未导入",
                                value: "0",
                            },
                            {
                                label: "已导入未上传",
                                value: "1",
                            },
                            {
                                label: "退回",
                                value: "3",
                            },
                            {
                                label: "待审",
                                value: "4",
                            },
                            {
                                label: "已经发布",
                                value: "5",
                            },
                        ];
                        if (this.hostname.indexOf('liaocheng.21js') > -1) {
                            this.statusData.push({
                                label: "待终审",
                                value: "绩效科待审",
                            })
                        } else {
                            this.statusData.push({
                                label: "业务科室审核完成",
                                value: "2",
                            })
                        }
                        this.lxSelectData = [
                            {
                                label: "单位",
                                value: "0",
                            },
                            {
                                label: "部门",
                                value: "2",
                            },
                        ];
                    }
                }
                if (this.userDetail.permissions) {
                    this.tgShow = this.userDetail.permissions.indexOf("9d7181a125d24457bcae5b384ac9db23") > 0 ? true : false;
                    this.thShow = this.userDetail.permissions.indexOf("90a210b600c348f3a75b8072be87ec3b") > 0 ? true : false;
                    this.lxShow = this.userDetail.permissions.indexOf("56aa5de5da2d487080b2535b53ece30e") > 0 ? true : false;
                    this.fbShow = this.userDetail.permissions.indexOf("8d54a755b3924e75bf31df40da206622") > 0 ? true : false;
                }
                this.allLoading = false;
            },
            async search() {
                // 不处理的原始数据进行搜索筛选
                // 重新调接口获取原始数据
                await this.getDivsList();
                if (this.form.km == '' && this.form.name == '' && this.form.zone == '' && this.form.parent == '' && this.form.state == '' && this.form.type == '') {
                } else {
                    this.tableData = []
                    if (this.form.type == '0') { //如果是查找单位,不需要树形列表
                        if (this.form.parent.length > 0) {
                            let arr = [];
                            let arrData = this.oldData;
                            this.oldData = [];
                            for (var i = 0; i < this.form.parent.length; i++) {
                                arr = arrData.filter((item) => item.ks == this.form.parent[i]);
                                this.oldData.push.apply(this.oldData, arr);
                            }
                        }
                        this.oldData.sort(function (a, b) {
                            return a.autoid - b.autoid
                        })
                        if (this.hostname.indexOf('liaocheng.21js') > -1 && this.form.state=='绩效科待审') {
                            this.tableData = this.oldData.filter((item) => item.name.indexOf(this.form.name) > -1 && item.stateName == this.form.state && item.type.toString().indexOf(this.form.type) > -1);
                        } else {
                            this.tableData = this.oldData.filter((item) => item.name.indexOf(this.form.name) > -1 && item.state.toString().indexOf(this.form.state) > -1 && item.type.toString().indexOf(this.form.type) > -1);
                        }
                    } else {
                        if (this.form.parent.length > 0) { //查询科室
                            let arr = [];
                            let arrData = this.oldData;
                            this.oldData = [];
                            for (var i = 0; i < this.form.parent.length; i++) {
                                arr = arrData.filter(item => {
                                    return item.ks == this.form.parent[i]
                                })
                                this.oldData.push.apply(this.oldData, arr);
                            }
                        }
                        this.oldData.forEach(item => item.children = [])
                        this.oldData.sort(function (a, b) {
                            return a.autoid - b.autoid
                        })
                        if (this.hostname.indexOf('liaocheng.21js') > -1 && this.form.state == '绩效科待审') {
                            this.tableData = this.oldData.filter(item => {
                                return item.name.indexOf(this.form.name) > -1 && item.stateName==this.form.state && item.type.toString().indexOf(this.form.type) > -1 || item.flag
                            })
                        } else {
                            this.tableData = this.oldData.filter(item => {
                                return item.name.indexOf(this.form.name) > -1 && item.state.toString().indexOf(this.form.state) > -1 && item.type.toString().indexOf(this.form.type) > -1 || item.flag
                            })
                        }
                        
                    }
                    this.$refs.tableRef.clearSelection()
                }
            },
            // 通过审核
            async tongyi() {
                let divids = this.selectData.filter((e) => e.id).map((i) => i.id).toString();

                if (divids == "") {
                    this.$message("未选择单位");
                    return
                } else {
                    let dividList = divids.split(",")
                    this.allLoading = true
                    let res;
                    for (let index = 0; index < dividList.length; index++) {
                        const element = dividList[index];
                        res = await tongyi({ id: element });
                    }

                    if (res.status == 0 || JSON.stringify(res) == "{}") {
                        this.$message.success("审核成功");
                        this.getDivsList();
                    }
                    this.allLoading = false
                }
            },
            //退回
            async tuihui() {
                let divids = this.selectData.filter((e) => e.id).map((i) => i.id).toString();
                if (divids == "") {
                    this.$message("未选择单位");
                    return
                } else {
                    let dividList = divids.split(",")

                    this.$prompt('请输入退回原因', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(async ({ value }) => {
                        let isempty = this.isEmptyStr(value)
                        if (isempty) {
                            this.$message("请输入退回原因")
                            return;
                        }
                        this.allLoading = true
                        var res;
                        for (let index = 0; index < dividList.length; index++) {
                            const element = dividList[index];
                            res = await tuihui({ id: element, reply: value })
                        }
                        if (res.status == 0) {
                            this.$message.success("退回成功");
                            this.getDivsList();
                        }
                        this.allLoading = false
                    });
                }
            },
            //发布
            async fabu() {

                let divids = this.selectData.filter((e) => e.id).map((i) => i.id).toString();
                if (divids == "") {
                    this.$message("未选择单位");
                    return
                } else {
                    let dividList = divids.split(",")
                    var con = confirm("确定发布？");
                    if (con) {
                        this.allLoading = true
                        var res;
                        for (let index = 0; index < dividList.length; index++) {
                            const element = dividList[index];
                            res = await fabu({ id: element });
                        }

                        if (res.status == 0 || JSON.stringify(res) == "{}") {
                            this.$message.success("发布成功");
                            this.getDivsList();
                        } else if (res.status == 1) {
                            this.$message.error(res.phrase);
                        }
                        this.allLoading = false
                    }
                }
            },
            //获取htmlurl地址
            async getHtmlurl() {
                this.htmlurl = window.location.origin
                if (this.htmlurl.indexOf("localhost") == -1) {
                    this.htmlurl += "/pdfHtml";
                } else {
                    let tertiaryDns = window.location.host.split(".")[1];
                    this.htmlurl = this.htmlurl.slice(0, this.htmlurl.indexOf(tertiaryDns));
                    this.htmlurl += `${tertiaryDns}.czyjsgk.com:2617/pdfHtml`;
                }
            },
            selectChange(val) {
                this.selectData = val;
            },

            //批量下载pdf
            async downmultiplepdf() {
                if (this.selectData.length > 0) {
                    this.allLoading = true;
                    var pdfNameConfig = ""
                    let res = await getPdfFileNameProfile()
                    if (res.status == 0 && res.expr) {
                        pdfNameConfig = res.expr
                    }
                    let urlhtml = window.location.origin;
                    await this.getHtmlurl()
                    let list = {
                        未上传:[],
                        财政审核:[],
                        服务器繁忙:[],
                        格式错误:[],
                        下载出错:[],
                    }
                    for (let index = 0; index < this.selectData.length; index++) {
                        const e = this.selectData[index];
                        if (e.state == "0" || e.state == "1" || e.state == "3") {
                            list.未上传.push(e.name)
                            continue;
                        } else if (urlhtml.indexOf("bincheng") > 0 && e.state != "5") {
                            list.财政审核.push(e.name)
                            continue;
                        }
                        const query = {
                            id: e.id,
                            name: getPdfName(e.name, e.type, this.openYear),
                            download: true,
                            htmlurl: this.htmlurl + `?divid=${e.id}`,
                        };
                        let res = await downLoadpdf(query);
                        if (res) {
                            if (res.type == 'application/json') {
                                list.服务器繁忙.push(e.name)
                                continue
                            } else if (res.type != "application/pdf") {
                                list.格式错误.push(e.name)
                                continue
                            } else {
                                var blob = new Blob([res], { type: "application/pdf" });
                                var url = URL.createObjectURL(blob);
                                var link = document.createElement("a");
                                link.download = query.name
                                link.href = url;
                                link.click();
                                continue
                            }
                        } else {
                            list.下载出错.push(e.name)
                            continue
                        }
                    }
                    for(let key in list){
                        if(list[key].length == 0){
                            delete list[key]
                        }
                    }
                    if(Object.keys(list).length > 0){
                        this.pdfErrorList = list
                        this.dialogdownLoadVisible = true
                    }
                    function getPdfName(divname, divtype) {
                        let folder = window.location.host.split(".")[1];
                        let openYear = Number('20' + folder.substring(0, 2))
                        let openType = folder.substring(2, 4)
                        var expr = pdfNameConfig.replace("{year}", openYear).replace("{divtype}", divtype == 0 ? '' : '部门').replace("{type}", localStorage.getItem('type') ? localStorage.getItem('type') : (openType == 'js' ? '决算' : '预算')).replace("{divname}", divname)
                        return expr
                    }
                    this.allLoading = false;
                } else {
                    this.$alert("请选择单位");
                    return
                }
            },

            //批量导入
            async pldr() {
                this.$router.push({ path: "/import" });
            },
            //单位编码
            sortscope(a, b) {
                return a.code - b.code;
            },
            //e-table 数据过滤筛选用的方法
            filterTag(value, row) {
                return row.state == value;
            },
            divClick(row) {
                let arr = []
                if (!row.bm) {
                    arr = ((this.tableData.find(e => e.id == row.id) || { children: [] }).children).map(function (item) {
                        return item['id'];
                    });
                }
                this.$store.commit("changeUnitList", arr.join(","));
                this.$store.commit("changeDivid", row.id);
                this.$store.commit('resetMessage')
                this.$router.push({ name: "部门概况", query: { divid: row.id, sort: "one" }, });
            },
            goUser() {
                this.$router.push({ name: "单位列表" });
            },
            rowSelect(selection, row) {
                if (!row.children) {
                    return
                }
                if (selection.some(el => { return row.id === el.id })) {
                    if (row.children) {
                        row.children.map(j => {
                            this.toggleSelection(j, true)
                        })
                    }
                } else {
                    if (row.children) {
                        row.children.map(j => {
                            this.toggleSelection(j, false)
                        })
                    }
                }
            },
            selectAll(selection) {
                if (!this.childrenType) {
                    return
                }
                // tabledata第一层只要有在selection里面就是全选
                const isSelect = selection.some(el => {
                    const tableDataIds = this.tableData.map(j => j.id)
                    return tableDataIds.includes(el.id)
                })
                // tableDate第一层只要有不在selection里面就是全不选
                const isCancel = !this.tableData.every(el => {
                    const selectIds = selection.map(j => j.id)
                    return selectIds.includes(el.id)
                })
                if (isSelect) {
                    selection.map(el => {
                        if (el.children) {
                            el.children.map(j => {
                                this.toggleSelection(j, true)
                            })
                        }
                    })
                }
                if (isCancel) {
                    this.tableData.map(el => {
                        if (el.children) {
                            el.children.map(j => {
                                this.toggleSelection(j, false)
                            })
                        }
                    })
                }
            },
            toggleSelection(row, select) {
                if (row) {
                    this.$nextTick(() => {
                        this.$refs.tableRef && this.$refs.tableRef.toggleRowSelection(row, select)
                    })
                }
            },
            doSearch(val) {
                this.form = {
                    zone: "",
                    parent: "",
                    name: "",
                    state: "",
                    km: "",
                    type: "",
                }
                switch (val) {
                    case '未导入':
                        this.form.state = '0';
                        break;
                    case '已导入':
                        this.form.state = '1';
                        break;
                    case '审核成功':
                        this.form.state = '2';
                        break;
                    case '退回':
                        this.form.state = '3';
                        break;
                    case '待审':
                        this.form.state = '4';
                        break;
                    case '已经发布':
                        this.form.state = '5';
                        break;
                    case '部门':
                        this.form.type = '2';
                        break;
                    case '单位':
                        this.form.type = '0';
                        break;
                    default:
                        this.form.type = '';
                        this.form.state = '';
                }
                this.search()
            },
            async check() {
                let that = this;
                that.allLoading = true;
                let errorType = false;
                let exprList = {};
                let resBdata = await getBdata();
                for (var len = 0; len < that.tableData.length; len++) {
                    let message = [];
                    await getDivList({
                        id: that.tableData[len].id
                    }).then(async res => {
                        if (res.status == 0) {
                            resBdata.bdata.forEach((e) => {
                                if (that.preview(e.expr, res.tables).result) {
                                    exprList[e.name] = that.preview(e.expr, res.tables).result;
                                } else {
                                    errorType = true
                                }
                            });
                            if (errorType) {
                                that.$message.error(res.divname + '数据异常!')
                            } else {
                                if (this.$store.state.openYear == 2020) {
                                    if (that.num(exprList.T6.总计).toFixed(2) != that.num(that.num(exprList.T6.人员经费) + that.num(exprList.T6.公用经费)).toFixed(2)) {
                                        message.push("《六、一般公共预算财政拨款基本支出情况说明》及第六张公开表，人员经费与公用经费之和与财政拨款基本支出总数不相等。");
                                    }
                                    if (JSON.stringify(exprList.F03) != "{}") {
                                        res.qksm['购置车辆'] = that.pickOneOf(res.qksm['购置车辆'], that.num(exprList.F03["购置车辆"]))
                                        res.qksm['国内接待费'] = that.pickOneOf(res.qksm['国内接待费'], that.num(exprList.F03["国内接待费"]))
                                        res.qksm['国外接待费'] = that.pickOneOf(res.qksm['国外接待费'], that.num(exprList.F03["国外接待费"]))
                                        res.qksm['中小企业合同'] = that.pickOneOf(res.qksm['中小企业合同'], that.num(exprList.F03["中小企业"]))
                                        res.qksm['小微企业合同'] = that.pickOneOf(res.qksm['小微企业合同'], that.num(exprList.F03["小微企业"]))
                                    }
                                    if (that.num(exprList.T7.items.购置费) > 0 && that.num(res.qksm['购置车辆']) == 0) {
                                        message.push("《七、一般公共预算财政拨款“三公”经费支出决算情况说明（二）“三公”经费支出决算具体情况》，使用财政拨款购置公务用车应大于0辆。");
                                    }
                                    if (that.num(exprList.T7.items.公务接待).toFixed(2) != that.num(that.num(res.qksm['国内接待费']) + that.num(res.qksm['国外接待费'])).toFixed(2)) {
                                        message.push("《七、一般公共预算财政拨款“三公”经费支出决算情况说明（二）“三公”经费支出决算具体情况》，国内公务接待与国（境）外公务接待之和与公务接待费不相等。");
                                    }
                                    let obj = Object.values({
                                        政府采购总计: that.pickOneOf(res.qksm['政府采购总计'], exprList.F03['政府采购合计']),
                                        政府采购货物: that.pickOneOf(res.qksm['政府采购货物'], exprList.F03['政府采购货物']),
                                        政府采购工程: that.pickOneOf(res.qksm['政府采购工程'], exprList.F03['政府采购工程']),
                                        政府采购服务: that.pickOneOf(res.qksm['政府采购服务'], exprList.F03['政府采购服务']),
                                    })
                                    var sum = 0;
                                    for (var i1 = 1; i1 < obj.length; i1++) {
                                        sum = sum + that.num(obj[i1])
                                    }
                                    if (that.num(obj[0]).toFixed(2) != that.num(sum).toFixed(2)) {
                                        message.push("《十、其他重要事项情况说明（二）政府采购支出情况》中政府采购分项支出金额合计应等于政府采购支出总额。");
                                    }
                                    if (that.num(res.qksm['中小企业合同']) > that.num(obj[0])) {
                                        message.push("《十、其他重要事项情况说明（二）政府采购支出情况》中填写的授予中小企业合同金额应该小于等于政府采购支出总额。");
                                    }
                                    if (that.num(res.qksm['小微企业合同']) > that.num(res.qksm['中小企业合同'])) {
                                        message.push("《十、其他重要事项情况说明（二）政府采购支出情况》中填写的授予小微企业合同金额应该小于等于填写的授予中小企业合同金额。");
                                    }
                                    var arr = ["共有车辆", "领导用车", "机要通信用车", "应急保障用车", "执法执勤用车", "特种专业用车", "离退休干部用车", "其他用车"]
                                    var car = [];
                                    for (var i2 = 0; i2 < arr.length; i2++) {
                                        car[arr[i2]] = res.qksm[arr[i2]]
                                        car[arr[i2]] = that.pickOneOf(res.qksm[arr[i2]], that.num(exprList.F03[arr[i2]]))
                                    }
                                    arr = Object.values(car)
                                    sum = 0;
                                    for (var i3 = 1; i3 < arr.length; i3++) {
                                        sum = sum + that.num(arr[i3])
                                    }
                                    if (that.num(arr[0]).toFixed(2) != that.num(sum).toFixed(2)) {
                                        message.push("《十、其他重要事项情况说明（三）国有资产占用情况》中各项车辆使用情况总和应该等于共有车辆总数。");
                                    }
                                } else if (this.$store.state.openYear == 2022) {
                                    res.attachments = await this.getAttachments(that.tableData[len].id)
                                    if (this.num(res.qksm['绩效项目支出']) > 0 && res.qksm['预算资金涉密'] != '是' && res.attachments.filter(e => e.claims.tag == 'jxmbb').length == 0) {
                                        message.push("请上传部门预算重点项目的绩效目标表。");
                                    } else if ((this.num(res.qksm['绩效项目支出']) == 0 || res.qksm['预算资金涉密'] == '是') && res.attachments.filter(e => e.claims.tag == 'jxmbb').length > 0) {
                                        message.push("请删除部门预算重点项目的绩效目标表。");
                                    }
                                }
                                if (message.length > 0) {
                                    that.checkData.push({ "divname": res.divname, "message": message.join('<br />') })
                                }
                                if (len == (that.tableData.length - 1)) {
                                    that.allLoading = false;
                                    if (that.checkData.length > 0) {
                                        that.dialogCheckVisible = true
                                    }
                                }
                            }

                        }
                    })

                }

            },
            async getAttachments(id) {
                let list = []
                let nums = 1;
                let res = {}
                do {
                    res = await getPerformanceList({
                        id: id,
                        tags: "jxmbb,bmzxzj",
                        pageNumber: nums,
                        pageSize: 20,
                    });
                    list = list.concat(res.files);
                    nums++
                }
                while (res.files.length == 20)
                return list
            },
            preview(expr, tables) {
                try {
                    let result = eval(this.makeEnvCode(tables) + expr);
                    return {
                        result,
                    };
                } catch (ex) {
                    return {
                        ex,
                    };
                }
            },
        },
    };
</script>
<style scoped>
    .el-table {
        position: absolute;
    }

    .grData {
        position: static !important;
    }

    .el-form {
        width: 75%;
        height: 65px;
        float: left;
    }

        .el-form .el-input,
        .el-form .el-select {
            float: left;
            width: 10%;
            margin-right: 10px;
            margin-top: 16px;
            z-index: 1;
        }

        .el-form .el-button {
            margin-top: 16px;
        }

        .el-form label {
            float: left;
            color: #fff;
            line-height: 65px;
            font-size: 14px;
            padding: 0 5px;
        }

    .active {
        text-indent: 1.6em;
        display: inline-block;
    }

    .tips {
        position: sticky;
        top: 0;
        z-index: 99;
    }

    .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        width: 100%;
        height: 53px;
        background: #F5F7FA;
        z-index: 9;
        font-family: fangsong;
    }

    .search {
        position: relative
    }

    .footer-c {
        margin: 0 20px;
    }
</style>